import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Loading } from 'components/Loading'
import { useTranslation } from 'react-i18next'
import { useInvitationsQuery } from 'services/invitations'

type Props = {
  tenderId: string
}

export const InvitedOrganizationsTable = ({ tenderId }: Props) => {
  const { t } = useTranslation()
  const { data: invitations, isLoading } = useInvitationsQuery({ tenderId })

  if (isLoading) {
    return <Loading fullPage={false} />
  }

  if (invitations === undefined) {
    return <></>
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('organization-name')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('orgEmailAddress')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t('invitationStatus')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invitations.items.map((invitation) => (
            <TableRow key={invitation.id}>
              <TableCell>{invitation.recipientName}</TableCell>
              <TableCell>{invitation.recipientEmail}</TableCell>
              <TableCell>{t(`invitationStatus-${invitation.status}`)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
